<template>
    <div class="expertise-details-skeleton">
        <SkeletonLoader max-width="369px" height="20px" :border-radius="skeletonBorderRadius" />
        <SkeletonLoader max-width="299px" height="20px" :border-radius="skeletonBorderRadius" />
        <div class="categories">
            <SkeletonLoader width="160px" max-width="160px" height="53px" :border-radius="skeletonBorderRadius" />
            <SkeletonLoader max-width="220px" height="53px" :border-radius="skeletonBorderRadius" />
            <SkeletonLoader max-width="190px" height="53px" :border-radius="skeletonBorderRadius" />
            <SkeletonLoader max-width="240px" height="53px" :border-radius="skeletonBorderRadius" />
            <SkeletonLoader max-width="220px" height="53px" :border-radius="skeletonBorderRadius" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import SkeletonLoader from '@malt/joy-entrypoint/src/vue/SkeletonLoader.vue';

    const skeletonBorderRadius = '8px';
</script>

<style scoped lang="scss">
    $margin: 8px;

    .expertise-details-skeleton {
        background-color: var(--joy-color-neutral-20);
        padding: 24px;
        border-radius: var(--joy-core-radius-3);

        .skeleton {
            margin-bottom: 12px;
            background-color: var(--joy-color-neutral-30);
        }

        .categories {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            gap: 16px 8px;

            .skeleton {
                margin: 0 $margin * 2 0 0;
            }
        }
    }
</style>
